/**
 * Pincode warehouse (StoreContext.store_code) + POST /apps/booking-api/check-inventory
 * → cap qty vs availableQty, then cart/add with properties['_Fulfillment Node'].
 */
(function () {
  'use strict';

  var CHECK_URL = '/apps/booking-api/check-inventory';
  /** Line item property for fulfillment routing (must match PDP hidden input name). */
  var FULFILLMENT_PROP = '_Fulfillment Node';

  var _productFormInvTimer;
  var _cartInventoryInlineTimer;
  /** Timeouts for theme per-line cart errors (`ref="cartItemError-*"`). */
  var _cartLineInvTimers = {};
  /** Lazily parsed #FabelleFlowInventoryMap (PDP) — set null when absent. */
  var _flowInvMapCache;

  function getFlowInventoryMap() {
    if (_flowInvMapCache !== undefined) return _flowInvMapCache;
    var el = document.getElementById('FabelleFlowInventoryMap');
    if (!el || !el.textContent) {
      _flowInvMapCache = null;
      return null;
    }
    try {
      _flowInvMapCache = JSON.parse(el.textContent);
    } catch (e) {
      _flowInvMapCache = null;
    }
    return _flowInvMapCache;
  }

  function qtyFromFlowRow(row, locationCode) {
    if (!row || !locationCode) return null;
    var sc = String(locationCode).trim().toUpperCase();
    var fcb = parseInt(row.FCB, 10);
    var fcm = parseInt(row.FCM, 10);
    var fcc = parseInt(row.FCC, 10);
    var a = Number.isFinite(fcb) ? fcb : 0;
    var b = Number.isFinite(fcm) ? fcm : 0;
    var c = Number.isFinite(fcc) ? fcc : 0;
    if (sc.indexOf('FCB') >= 0 || sc === 'FCB') return a;
    if (sc.indexOf('FCM') >= 0 || sc === 'FCM') return b;
    if (sc.indexOf('FCC') >= 0 || sc === 'FCC') return c;
    return Math.max(a, b, c);
  }

  /**
   * Flow metafield stock (FCB/FCM/FCC). Returns a number @ location, or null → use booking check-inventory.
   */
  function getFlowAvailableQtyForVariant(variantId, locationCode) {
    if (variantId == null || locationCode == null || locationCode === '') return null;
    var vid = String(variantId);
    var map = getFlowInventoryMap();
    if (map && map[vid]) {
      return qtyFromFlowRow(map[vid], locationCode);
    }
    var card = document.querySelector(
      '.fcs-card[data-variant-id="' +
        vid +
        '"][data-fabelle-flow-inv],.fpl-card[data-variant-id="' +
        vid +
        '"][data-fabelle-flow-inv],.ffc-card[data-variant-id="' +
        vid +
        '"][data-fabelle-flow-inv],.ffa-card[data-variant-id="' +
        vid +
        '"][data-fabelle-flow-inv],.fcr-card[data-variant-id="' +
        vid +
        '"][data-fabelle-flow-inv]'
    );
    if (card) {
      return qtyFromFlowRow(
        {
          FCB: card.getAttribute('data-fabelle-inv-fcb'),
          FCM: card.getAttribute('data-fabelle-inv-fcm'),
          FCC: card.getAttribute('data-fabelle-inv-fcc'),
        },
        locationCode
      );
    }
    var formHosts = document.querySelectorAll('product-form-component[data-fabelle-flow-inv]');
    var fh;
    for (fh = 0; fh < formHosts.length; fh++) {
      var pfc = formHosts[fh];
      var idInput = pfc.querySelector('input[name="id"]');
      if (idInput && String(idInput.value) === vid) {
        return qtyFromFlowRow(
          {
            FCB: pfc.getAttribute('data-fabelle-inv-fcb'),
            FCM: pfc.getAttribute('data-fabelle-inv-fcm'),
            FCC: pfc.getAttribute('data-fabelle-inv-fcc'),
          },
          locationCode
        );
      }
    }
    var tr = document.querySelector(
      'tr.cart-items__table-row[data-variant-id="' + vid + '"][data-fabelle-flow-inv]'
    );
    if (tr) {
      return qtyFromFlowRow(
        {
          FCB: tr.getAttribute('data-fabelle-inv-fcb'),
          FCM: tr.getAttribute('data-fabelle-inv-fcm'),
          FCC: tr.getAttribute('data-fabelle-inv-fcc'),
        },
        locationCode
      );
    }
    return null;
  }

  /** Theme web components may use shadow DOM; querySelector on the host does not pierce. */
  function findInRoot(selector, root) {
    if (!root || !root.querySelector) return null;
    var el = root.querySelector(selector);
    if (el) return el;
    if (root.shadowRoot) {
      el = findInRoot(selector, root.shadowRoot);
      if (el) return el;
    }
    var nodes = root.querySelectorAll('*');
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        el = findInRoot(selector, nodes[i].shadowRoot);
        if (el) return el;
      }
    }
    return null;
  }

  function qtyInputInSelectorComp(comp) {
    if (!comp) return null;
    var tag = comp.tagName || '';
    if (tag === 'CART-QUANTITY-SELECTOR-COMPONENT') {
      return findInRoot('input[name="updates[]"]', comp);
    }
    if (tag === 'QUANTITY-SELECTOR-COMPONENT') {
      return findInRoot('input[name="quantity"]', comp);
    }
    return null;
  }

  /** closest() does not cross shadow root; walk through ShadowRoot.host */
  function findQtySelectorHostFromNode(node) {
    var n = node;
    while (n) {
      var tag = n.tagName || '';
      if (tag === 'CART-QUANTITY-SELECTOR-COMPONENT' || tag === 'QUANTITY-SELECTOR-COMPONENT') {
        return n;
      }
      var p = n.parentNode;
      if (p instanceof ShadowRoot) {
        n = p.host;
      } else {
        n = p;
      }
    }
    return null;
  }

  function findCartAddFormFromNode(node) {
    var n = node;
    while (n) {
      if (n.tagName === 'FORM') {
        var act = n.getAttribute && n.getAttribute('action');
        if (act && act.indexOf('/cart/add') !== -1) return n;
      }
      var p = n.parentNode;
      if (p instanceof ShadowRoot) n = p.host;
      else n = p;
    }
    return null;
  }

  function showPdpError(message) {
    if (!message) {
      return;
    }
    /* Match home / collection: pink #e5007e fixed top bar (getOrCreateFabelleCartInventoryTopbar) */
    if (typeof showCartInventoryInline === 'function' && showCartInventoryInline(message)) {
      return;
    }
    var host = document.querySelector('[data-pdp-store-message]');
    if (host) {
      host.innerHTML =
        '<span style="color:#d32f2f;font-weight:bold;">' + escapeHtml(message) + '</span>';
    } else {
      window.alert(message);
    }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function resolveDesktopPlacement(opts) {
    var p = opts && opts.placement;
    if (p === 'product' || p === 'cart') return p;
    if (document.querySelector('cart-drawer-component dialog[open]')) return 'cart';
    if (document.querySelector('product-form-component')) return 'product';
    return 'cart';
  }

  /** Same inline row as theme add-to-cart errors (buy-buttons .product-form-text__error). */
  function showInProductFormError(message) {
    var list = document.querySelectorAll('product-form-component');
    var i;
    for (i = 0; i < list.length; i++) {
      var err = findInRoot('.product-form-text__error', list[i]);
      if (!err) continue;
      err.classList.remove('hidden');
      var textNode = err.childNodes[2];
      if (textNode && textNode.nodeType === 3) {
        textNode.textContent = message;
      } else {
        while (err.childNodes.length > 2) {
          err.removeChild(err.lastChild);
        }
        err.appendChild(document.createTextNode(message));
      }
      var lr = findInRoot('[ref="liveRegion"]', list[i]);
      if (lr) lr.textContent = message;
      clearTimeout(_productFormInvTimer);
      _productFormInvTimer = setTimeout(function () {
        err.classList.add('hidden');
        if (lr) lr.textContent = '';
      }, 7000);
      return true;
    }
    return false;
  }

  /**
   * Full-width fixed top bar (cart page + cart drawer, all breakpoints) — Fabelle pink #e5007e, white text.
   * Replaces legacy inline banner inside the drawer.
   */
  function getOrCreateFabelleCartInventoryTopbar() {
    var old = document.getElementById('fabelle-cart-inventory-message');
    if (old && old.parentNode) {
      old.parentNode.removeChild(old);
    }
    var id = 'fabelle-cart-inventory-topbar';
    var n = document.getElementById(id);
    if (n) return n;
    n = document.createElement('div');
    n.id = id;
    n.className = 'fabelle-cart-inventory-topbar';
    n.setAttribute('role', 'alert');
    n.setAttribute('aria-live', 'assertive');
    n.style.cssText =
      'display:none;box-sizing:border-box;position:fixed;z-index:100002;top:0;left:0;right:0;width:100%;' +
      'margin:0;padding:14px 20px;font-size:15px;line-height:1.35;font-weight:500;letter-spacing:0.01em;' +
      'text-align:center;color:#fff;background:#e5007e;box-shadow:0 1px 0 rgba(0,0,0,0.08);' +
      "font-family:'General Sans',system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;border-radius:0;";
    document.body.appendChild(n);
    return n;
  }

  function showCartInventoryInline(message) {
    var host = getOrCreateFabelleCartInventoryTopbar();
    if (!host) return false;
    host.textContent = message;
    host.style.display = 'block';
    clearTimeout(_cartInventoryInlineTimer);
    _cartInventoryInlineTimer = setTimeout(function () {
      host.style.display = 'none';
      host.textContent = '';
    }, 8000);
    return true;
  }

  function showInvError(message, opts) {
    if (!message) return;
    var place = resolveDesktopPlacement(opts);
    if (place === 'product' && showInProductFormError(message)) return;
    if (showCartInventoryInline(message)) return;
    window.alert(message);
  }

  window.fabelleShowInventoryError = showInvError;

  function getCartLineIndexFromQtyHost(comp) {
    if (!comp) return null;
    var input = qtyInputInSelectorComp(comp);
    if (!input) return null;
    var line = parseInt(input.getAttribute('data-cart-line'), 10);
    return Number.isFinite(line) && line > 0 ? line : null;
  }

  /**
   * Same stock message as the pink top bar; use that first so cart page / drawer match the reference.
   * Falls back to the theme row (cart-products.liquid) if the top bar cannot be created.
   */
  function showThemeCartLineInventoryError(line, message) {
    if (!line || !message) return false;
    var dedupKey = String(line) + '\0' + message;
    var now = Date.now();
    if (
      showThemeCartLineInventoryError._lastKey === dedupKey &&
      now - showThemeCartLineInventoryError._lastAt < 1400
    ) {
      return true;
    }
    showThemeCartLineInventoryError._lastKey = dedupKey;
    showThemeCartLineInventoryError._lastAt = now;
    if (showCartInventoryInline(message)) {
      return true;
    }
    var textEl = document.querySelector('[ref="cartItemError-' + line + '"]');
    var container = document.querySelector('[ref="cartItemErrorContainer-' + line + '"]');
    if (!textEl || !container) return false;
    textEl.textContent = message;
    container.classList.remove('hidden');
    clearTimeout(_cartLineInvTimers[line]);
    _cartLineInvTimers[line] = setTimeout(function () {
      hideThemeCartLineInventoryError(line);
    }, 8000);
    return true;
  }

  function hideThemeCartLineInventoryError(line) {
    if (!line) return;
    clearTimeout(_cartLineInvTimers[line]);
    delete _cartLineInvTimers[line];
    var textEl = document.querySelector('[ref="cartItemError-' + line + '"]');
    var container = document.querySelector('[ref="cartItemErrorContainer-' + line + '"]');
    if (container) container.classList.add('hidden');
    if (textEl) textEl.textContent = '';
  }

  function showLocationStockCapMessage(cap, placement, qtyHost) {
    var n = parseInt(cap, 10);
    if (!Number.isFinite(n) || n < 0) return;
    var msg =
      'Only ' + n + (n === 1 ? ' item' : ' items') + ' available at your location for this product.';
    var now = Date.now();
    if (msg === showLocationStockCapMessage._lastMsg && now - showLocationStockCapMessage._lastAt < 1200) {
      return;
    }
    showLocationStockCapMessage._lastMsg = msg;
    showLocationStockCapMessage._lastAt = now;
    if (placement === 'cart' && qtyHost) {
      var line = getCartLineIndexFromQtyHost(qtyHost);
      if (line && showThemeCartLineInventoryError(line, msg)) return;
    }
    var opts = placement ? { placement: placement } : undefined;
    showInvError(msg, opts);
  }

  function fetchCartJson() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return fetch(root + 'cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        return r.ok ? r.json() : { items: [] };
      })
      .catch(function () {
        return { items: [] };
      });
  }

  function sumVariantQty(cart, variantId) {
    var vid = String(variantId);
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return String(item.variant_id) === vid ? sum + item.quantity : sum;
    }, 0);
  }

  function sumOtherLinesSameVariant(cart, variantId, lineKey) {
    var vid = String(variantId);
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      if (String(item.variant_id) !== vid) return sum;
      if (lineKey && item.key === lineKey) return sum;
      return sum + item.quantity;
    }, 0);
  }

  function fetchLocationAvailableQty(variantId, locationCode, requestedQty) {
    var rq = Math.max(1, parseInt(requestedQty, 10) || 1);
    return fetch(CHECK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        variantId: variantId,
        locationCode: locationCode,
        requestedQty: rq,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (result) {
        if (result.availableQty === undefined || result.availableQty === null) return null;
        var n = parseInt(result.availableQty, 10);
        return Number.isFinite(n) ? n : null;
      });
  }

  /** Flow / DOM first; avoids N× check-inventory on cart:update when metafields are present. */
  function getAvailableQtyOrFetch(variantId, locationCode, requestedQty) {
    var flow = getFlowAvailableQtyForVariant(variantId, locationCode);
    if (flow !== null) {
      return Promise.resolve(flow);
    }
    return fetchLocationAvailableQty(variantId, locationCode, requestedQty);
  }

  /** Shared caps for booking API or Flow metafield qty. */
  function fabelleBuildInventoryValidateResult(cart, variantId, addQty, available) {
    var inCart = sumVariantQty(cart, variantId);

    if (available === null) {
      return {
        ok: false,
        message: 'Unable to verify stock at your location. Please try again.',
        inCart: inCart,
      };
    }

    var maxCanAdd = Math.max(0, available - inCart);

    if (addQty > maxCanAdd) {
      var message;
      if (available === 0) {
        message = 'Out of stock at your selected location.';
      } else if (inCart >= available) {
        message = 'You already have the maximum (' + available + ') for this item in your cart.';
      } else {
        message =
          'Only ' +
          available +
          (available === 1 ? ' item' : ' items') +
          ' available at your location. You can add ' +
          maxCanAdd +
          ' more (you have ' +
          inCart +
          ' in your cart).';
      }
      return {
        ok: false,
        message: message,
        maxTotal: available,
        inCart: inCart,
        maxCanAdd: maxCanAdd,
      };
    }

    return {
      ok: true,
      maxTotal: available,
      inCart: inCart,
      maxCanAdd: maxCanAdd,
    };
  }

  /** PLP / cards: Flow metafields first, else booking-api (null = no store or API miss). */
  window.fabelleGetLocationAvailableQty = function (variantId) {
    var ctx = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    var locationCode = ctx && ctx.store_code;
    if (!locationCode || variantId == null || variantId === '') {
      return Promise.resolve(null);
    }
    var flowQty = getFlowAvailableQtyForVariant(variantId, locationCode);
    if (flowQty !== null) {
      return Promise.resolve(flowQty);
    }
    return getAvailableQtyOrFetch(variantId, locationCode, 1);
  };

  window.fabelleValidateLocationInventory = function (opts) {
    var variantId = opts && opts.variantId;
    var addQty = Math.max(1, parseInt(opts && opts.addQty, 10) || 1);
    var ctx = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    var locationCode = ctx && ctx.store_code;

    if (!locationCode) {
      return Promise.resolve({ ok: true });
    }

    var flowQty = getFlowAvailableQtyForVariant(variantId, locationCode);
    if (flowQty !== null) {
      return fetchCartJson().then(function (cart) {
        return fabelleBuildInventoryValidateResult(cart, variantId, addQty, flowQty);
      });
    }

    return Promise.all([fetchCartJson(), getAvailableQtyOrFetch(variantId, locationCode, addQty)]).then(
      function (pair) {
        return fabelleBuildInventoryValidateResult(pair[0], variantId, addQty, pair[1]);
      }
    );
  };

  /** Replaces collection [data-atc] with “Sold out” when booking/Flow caps at 0 (grid prefetch removed; kept for post-add error). */
  window.fabelleMarkAtcAsLocationSoldOut = function (btn) {
    if (!btn || !(btn instanceof HTMLElement)) return;
    if (!btn.matches || (!btn.matches('[data-atc]') && !btn.matches('[data-atc-recommend]'))) return;
    if (!document.getElementById('fabelle-location-soldout-style')) {
      var s = document.createElement('style');
      s.id = 'fabelle-location-soldout-style';
      s.textContent =
        '.fabelle-location-soldout{font-family:General Sans,-apple-system,sans-serif;font-size:0.72rem;font-weight:300;color:#888;letter-spacing:0.05em;display:inline-flex;align-items:center;min-width:36px;min-height:36px;justify-content:flex-end;}';
      document.head.appendChild(s);
    }
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var span = document.createElement('span');
    span.className = 'fabelle-location-soldout';
    span.textContent = 'Sold out';
    span.setAttribute('data-fabelle-location-soldout', '');
    span.setAttribute('data-variant-id', vid);
    span.setAttribute('data-fabelle-atc-restore-class', btn.className);
    try {
      span.setAttribute('data-fabelle-atc-restore-html', encodeURIComponent(btn.innerHTML || ''));
    } catch (e) {
      span.setAttribute('data-fabelle-atc-restore-html', '');
    }
    var al = btn.getAttribute('aria-label');
    if (al) span.setAttribute('data-fabelle-atc-restore-label', al);
    btn.replaceWith(span);
  };

  /**
   * Collection quick-add: run validate (Flow or check-inventory), then call runAdd() (your fetch chain).
   */
  window.fabelleTryCartAddQuick = function (variantId, addQty, runAdd, atcButton) {
    addQty = Math.max(1, parseInt(addQty, 10) || 1);
    var ctx = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    if (!window.fabelleValidateLocationInventory || !ctx || !ctx.store_code) {
      runAdd();
      return;
    }
    window
      .fabelleValidateLocationInventory({ variantId: variantId, addQty: addQty })
      .then(function (res) {
        if (!res.ok) {
          if (
            atcButton &&
            typeof atcButton.isConnected === 'boolean' &&
            atcButton.isConnected &&
            Number(res.maxTotal) === 0 &&
            typeof window.fabelleMarkAtcAsLocationSoldOut === 'function'
          ) {
            window.fabelleMarkAtcAsLocationSoldOut(atcButton);
            return;
          }
          showInvError(res.message, { placement: 'auto' });
          return;
        }
        runAdd();
      })
      .catch(function () {
        showInvError('Unable to verify stock. Please try again.', { placement: 'auto' });
      });
  };

  /** Build /cart/add.js body with fulfillment property when pincode context exists. */
  window.fabelleCartAddPayload = function (variantId, quantity) {
    var ctx = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    var body = { id: parseInt(variantId, 10), quantity: quantity || 1 };
    if (ctx && ctx.store_code) {
      body.properties = {};
      body.properties[FULFILLMENT_PROP] = String(ctx.store_code).toUpperCase();
    }
    return body;
  };

  function enablePdpAddToCartControls(form, submitButton) {
    var roots = form.querySelectorAll('add-to-cart-component');
    var i;
    for (i = 0; i < roots.length; i++) {
      var el = roots[i];
      if (el && typeof el.enable === 'function') {
        try {
          el.enable();
        } catch (e) {}
      }
    }
    if (submitButton) {
      submitButton.disabled = false;
      if (submitButton.removeAttribute) submitButton.removeAttribute('disabled');
    }
  }

  /** When /cart/add.js returns a full cart shape, skip a follow-up GET /cart.js. */
  function cartLikeFromAddJsBody(body) {
    if (!body || body.status) return null;
    if (typeof body.item_count === 'number') return body;
    if (Array.isArray(body.items)) {
      var sum = 0;
      var i;
      for (i = 0; i < body.items.length; i++) {
        sum += Number(body.items[i].quantity) || 0;
      }
      return { item_count: sum, items: body.items };
    }
    return null;
  }

  function toastMessageForCartAdd(cart, variantId, requestedQty) {
    var items = cart.items || [];
    var i;
    var line;
    for (i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(variantId)) {
        line = items[i];
        break;
      }
    }
    if (line && line.quantity > requestedQty) {
      return 'Item quantity increased';
    }
    return 'Item added to your cart';
  }

  function tryOpenFabelleCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return true;
      }
      if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
        return true;
      }
    }
    var innerDrawer = document.querySelector('#CartDrawer, .cart-drawer, [data-cart-drawer]');
    if (innerDrawer) {
      innerDrawer.classList.add('is-open', 'active');
      innerDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return true;
    }
    return false;
  }

  /** Same as PLP quick-add: JSON /cart/add.js + cart:update (avoids shadow DOM / requestSubmit / theme submit quirks). */
  function pdpAddToCartViaApi(variantId, requestedQty, form, submitButton) {
    var cartAddUrl =
      window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url
        ? window.Theme.routes.cart_add_url
        : '/cart/add.js';
    var payload = window.fabelleCartAddPayload
      ? window.fabelleCartAddPayload(variantId, requestedQty)
      : { id: parseInt(variantId, 10), quantity: requestedQty };

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (body.status) {
            showPdpError(body.message || body.description || 'Could not add to cart.');
            throw new Error('cart-add-error');
          }
          return body;
        });
      })
      .then(function (addBody) {
        var cart = cartLikeFromAddJsBody(addBody);
        if (cart) return cart;
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        enablePdpAddToCartControls(form, submitButton);
        var toastMsg = toastMessageForCartAdd(cart, variantId, requestedQty);
        applyCartCountUiFromShopifyCart(cart);
        if (typeof window.fabelleShowMobileCartToast === 'function') {
          window.fabelleShowMobileCartToast(toastMsg);
        }
        if (window.matchMedia('(min-width: 750px)').matches) {
          if (!tryOpenFabelleCartDrawer() && window.customElements && customElements.whenDefined) {
            customElements.whenDefined('cart-drawer-component').then(tryOpenFabelleCartDrawer).catch(tryOpenFabelleCartDrawer);
          }
        }
      });
  }

  function enforceLocalQuantityLimit(variantId, activeStore) {
    Promise.all([fetchCartJson(), getAvailableQtyOrFetch(variantId, activeStore, 1)]).then(
      function (pair) {
        var cart = pair[0];
        var available = pair[1];
        var pdpForm = document.querySelector('form[action*="/cart/add"]');
        var qtyInput = pdpForm ? findInRoot('input[name="quantity"]', pdpForm) : null;
        var messageHost = document.querySelector('[data-pdp-store-message]');
        if (!qtyInput || !variantId || !activeStore || available === null) return;

        var inCart = sumVariantQty(cart, variantId);
        var maxCanAdd = Math.max(0, available - inCart);
        /* Theme uses effectiveMax = max - data-cart-quantity; max must be total at location, not "remaining". */
        qtyInput.max = available > 0 ? available : 0;
        if (qtyInput.dataset) qtyInput.dataset.max = String(available);

        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > maxCanAdd) qtyInput.value = String(Math.max(1, maxCanAdd));

        var qtyHost = findQtySelectorHostFromNode(qtyInput);
        if (qtyHost && typeof qtyHost.updateButtonStates === 'function') {
          qtyHost.updateButtonStates();
        }

        if (messageHost) {
          if (maxCanAdd <= 0 && available > 0) {
            messageHost.innerHTML =
              '<span style="color:#d32f2f;font-weight:bold;">You already have all ' +
              available +
              ' available items in your cart.</span>';
          } else if (available > 0) {
            messageHost.innerHTML =
              '<span style="color:#2e7d32;font-weight:bold;">In stock: ' +
              available +
              ' at your location. You can add up to ' +
              maxCanAdd +
              ' now' +
              (inCart > 0 ? ' (' + inCart + ' already in cart).' : '.') +
              '</span>';
          }
        }
      }
    );
  }

  /** Prevent overlapping /cart/update cap syncs (rapid cart:update + enforce). */
  var _locationCapSyncInFlight = false;

  function collectCartItemsSectionIds() {
    var set = {};
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) {
        set[el.dataset.sectionId] = true;
      }
    });
    return Object.keys(set);
  }

  /**
   * Persist location caps to Shopify so line totals, subtotal, and badges match qty inputs.
   * (Previously we only changed the input in the DOM — cart JSON still had the old qty.)
   */
  function persistInventoryCapsToShopify(updatesObj) {
    var keys = Object.keys(updatesObj);
    if (!keys.length) return Promise.resolve(null);

    var sectionIds = collectCartItemsSectionIds();
    var url =
      window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url
        ? window.Theme.routes.cart_update_url
        : '/cart/update.js';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        updates: updatesObj,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var parsed;
        try {
          parsed = JSON.parse(text);
        } catch (e) {
          console.warn('[Fabelle] location cap cart/update parse error');
          return null;
        }
        if (parsed.errors) {
          console.warn('[Fabelle] location cap cart/update failed', parsed.errors);
          return null;
        }
        return parsed;
      });
  }

  function dispatchCartUiAfterLocationCapSync(parsed) {
    if (!parsed) return;
    var n = totalUnitsFromShopifyCart(parsed);
    updateCartPageCountDom(n);
    syncHeaderCartBubbleAbsolute(n);
    if (typeof window.fabelleUpdateMobileNavCartBadge === 'function') {
      window.fabelleUpdateMobileNavCartBadge(n);
    }
    var sectionIds = collectCartItemsSectionIds();
    var primarySectionId = sectionIds[0] || '';
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: parsed,
          sourceId: primarySectionId,
          data: {
            itemCount: n,
            source: 'fabelle-location-cap-sync',
            sections: parsed.sections || {},
          },
        },
      })
    );
  }

  function enforceCartQuantityLimits() {
    var ctx = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    var activeStore = ctx && ctx.store_code;
    if (!activeStore) return;

    var components = document.querySelectorAll('cart-quantity-selector-component');
    if (!components.length) return;

    fetchCartJson().then(function (cart) {
      var tasks = [];
      var i;
      for (i = 0; i < components.length; i++) {
        (function (comp) {
          var input = qtyInputInSelectorComp(comp);
          if (!input) return;

          var variantId =
            comp.getAttribute('data-variant-id') || (comp.dataset && comp.dataset.variantId);
          if (!variantId) return;

          var row = comp.closest('tr[data-key]');
          var lineKey = row ? row.getAttribute('data-key') : null;
          if (!lineKey) return;

          tasks.push(
            getAvailableQtyOrFetch(variantId, activeStore, 1).then(function (available) {
              return {
                comp: comp,
                input: input,
                variantId: variantId,
                lineKey: lineKey,
                available: available,
              };
            })
          );
        })(components[i]);
      }

      if (!tasks.length) return;

      Promise.all(tasks).then(function (results) {
        var updates = {};
        var j;
        for (j = 0; j < results.length; j++) {
          var r = results[j];
          if (!r || r.available === null) continue;

          var otherSum = sumOtherLinesSameVariant(cart, r.variantId, r.lineKey);
          var maxThisLine = Math.max(0, r.available - otherSum);

          r.input.max = maxThisLine > 0 ? maxThisLine : 0;

          var lineNum = getCartLineIndexFromQtyHost(r.comp);
          var lineMsg =
            'Only ' +
            r.available +
            (r.available === 1 ? ' item' : ' items') +
            ' available at your location for this product.';

          var itemRow =
            cart.items &&
            cart.items.find(function (it) {
              return it.key === r.lineKey;
            });
          var serverQ = itemRow ? itemRow.quantity : parseInt(r.input.value, 10) || 0;

          if (serverQ > maxThisLine) {
            updates[r.lineKey] = maxThisLine;
          }

          var qDisplay = parseInt(r.input.value, 10) || 0;
          if (qDisplay > maxThisLine) {
            r.input.value = String(Math.max(0, maxThisLine));
            if (!(lineNum && showThemeCartLineInventoryError(lineNum, lineMsg))) {
              showInvError(lineMsg, { placement: 'cart' });
            }
          } else if (lineNum) {
            hideThemeCartLineInventoryError(lineNum);
          }

          if (typeof r.comp.updateButtonStates === 'function') {
            r.comp.updateButtonStates();
          }
        }

        if (!Object.keys(updates).length) return;
        if (_locationCapSyncInFlight) return;

        _locationCapSyncInFlight = true;
        persistInventoryCapsToShopify(updates)
          .then(function (parsed) {
            dispatchCartUiAfterLocationCapSync(parsed);
          })
          .finally(function () {
            _locationCapSyncInFlight = false;
          });
      });
    });
  }

  function handleAddToCartCapture(event) {
    var t = event.target;
    var clickEl = t && t.nodeType === 1 ? t : t && t.parentElement;
    if (!clickEl) return;
    var form = findCartAddFormFromNode(clickEl);
    if (!form) return;

    var context = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    var activeStore = context && context.store_code;

    if (!activeStore) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var submitButton =
      findInRoot('button[type="submit"][name="add"]', form) ||
      findInRoot('button[type="submit"]', form) ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('.add-to-cart');
    var variantInput = findInRoot('input[name="id"]', form);
    var qtyInput = findInRoot('input[name="quantity"]', form);
    // Read the synchronously-checked radio first — input[name="id"] lags behind the async
    // section fetch triggered by variant selection, so it may still hold the previous variant.
    var variantId = null;
    var formHost = form.closest('product-form-component');
    var productId = formHost && formHost.getAttribute('data-product-id');
    if (productId) {
      var vp = document.querySelector('variant-picker[data-product-id="' + productId + '"]');
      var checkedRadio = vp && vp.querySelector('fieldset input:checked');
      if (checkedRadio && checkedRadio.getAttribute('data-variant-id')) {
        variantId = checkedRadio.getAttribute('data-variant-id');
      }
    }
    if (!variantId) {
      variantId = variantInput ? variantInput.value : null;
    }
    var requestedQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    if (!variantId || !submitButton) return;

    submitButton.disabled = true;

    window
      .fabelleValidateLocationInventory({ variantId: variantId, addQty: requestedQty })
      .then(function (check) {
        if (!check.ok) {
          showPdpError(check.message);
          if (qtyInput && check.maxTotal !== undefined) {
            qtyInput.max = check.maxTotal;
            var maxCan = Math.max(0, check.maxTotal - (check.inCart || 0));
            if (parseInt(qtyInput.value, 10) > maxCan) {
              qtyInput.value = String(maxCan > 0 ? maxCan : 1);
            }
          }
          return;
        }

        return pdpAddToCartViaApi(variantId, requestedQty, form, submitButton);
      })
      .catch(function (err) {
        if (err && err.message === 'cart-add-error') return;
        showPdpError('Unable to verify stock. Please try again.');
      })
      .finally(function () {
        submitButton.disabled = false;
      });
  }

  function validatePDP() {
    var productPage =
      document.querySelector('product-form-component[data-product-page]') ||
      document.querySelector('[data-product-page]');
    if (!productPage || !window.StoreContext) return;

    var context = window.StoreContext.get();
    var activeStore = context && context.store_code;

    var pdpFormForBtns = document.querySelector('form[action*="/cart/add"]');
    var atcButtons = [];
    if (pdpFormForBtns) {
      var primaryBtn =
        findInRoot('button[type="submit"][name="add"]', pdpFormForBtns) ||
        findInRoot('button[type="submit"]', pdpFormForBtns);
      if (primaryBtn) atcButtons.push(primaryBtn);
    }

    if (!activeStore) {
      showPdpError('Please enter a pincode above to check delivery.');
      return;
    }

    /* Same as PLP quick-add: do not gate on Liquid location names (often mismatch store_code). check-inventory runs in handleAddToCartCapture. */
    var msgHost = document.querySelector('[data-pdp-store-message]');
    if (msgHost) msgHost.innerHTML = '';

    atcButtons.forEach(function (btn) {
      btn.disabled = false;
    });

    var pdpForm = pdpFormForBtns || document.querySelector('form[action*="/cart/add"]');
    var variantInput = pdpForm ? findInRoot('input[name="id"]', pdpForm) : null;
    if (variantInput && variantInput.value) {
      enforceLocalQuantityLimit(variantInput.value, activeStore);
    }

    atcButtons.forEach(function (btn) {
      btn.removeEventListener('click', handleAddToCartCapture, true);
      btn.addEventListener('click', handleAddToCartCapture, true);
    });
  }

  function validateCartPageUi() {
    var hasCartUi =
      document.querySelector('[data-cart-page]') ||
      document.querySelector('.cart-wrapper') ||
      document.querySelector('cart-items-component') ||
      document.querySelector('cart-quantity-selector-component');
    if (!hasCartUi) return;

    var context = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
    var messageHost = document.querySelector('[data-cart-store-validation]');

    if (!context) {
      if (messageHost) {
        messageHost.innerHTML =
          '<span style="color:#d32f2f;font-weight:bold;">Enter your delivery pincode to proceed.</span>';
      }
      document.querySelectorAll('[name="checkout"], .checkout-btn').forEach(function (btn) {
        btn.disabled = true;
      });
      return;
    }

    document.querySelectorAll('[name="checkout"], .checkout-btn').forEach(function (btn) {
      btn.disabled = false;
    });
    if (messageHost) messageHost.innerHTML = '';

    enforceCartQuantityLimits();
  }

  /**
   * Theme clamps + at max without feedback. If value did not increase and user hit + at cap, show message.
   */
  document.addEventListener(
    'blur',
    function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement)) return;

      if (t.matches('input[name="updates[]"]') && findQtySelectorHostFromNode(t)) {
        var ctxB = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
        if (!ctxB || !ctxB.store_code) return;
        var hostB = findQtySelectorHostFromNode(t);
        var lineB = getCartLineIndexFromQtyHost(hostB);
        if (lineB && _cartLinePointerCapUntil[lineB] && Date.now() < _cartLinePointerCapUntil[lineB]) {
          return;
        }
        var capB = parseInt(t.max, 10);
        var rawB = parseInt(t.value, 10) || 0;
        if (Number.isFinite(capB) && capB > 0 && rawB > capB) {
          showLocationStockCapMessage(capB, 'cart', hostB);
        }
        return;
      }

      if (t.matches('input[name="quantity"]') && findCartAddFormFromNode(t)) {
        var ctxP = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
        if (!ctxP || !ctxP.store_code) return;
        var maxP = parseInt(t.max, 10);
        var cartQP = parseInt(t.getAttribute('data-cart-quantity'), 10) || 0;
        var minP = parseInt(t.min, 10) || 1;
        if (!Number.isFinite(maxP) || maxP <= 0) return;
        var effP = Math.max(maxP - cartQP, minP);
        var rawP = parseInt(t.value, 10) || 0;
        if (rawP > effP) {
          showLocationStockCapMessage(maxP, 'product');
        }
      }
    },
    true
  );

  /**
   * + at max (incl. disabled): use pointerdown + composedPath so shadow DOM + disabled buttons still get feedback.
   */
  document.addEventListener(
    'pointerdown',
    function (e) {
      var plusBtn = null;
      if (typeof e.composedPath === 'function') {
        var path = e.composedPath();
        var k;
        for (k = 0; k < path.length; k++) {
          var node = path[k];
          if (node && node.matches && node.matches('button[name="plus"]')) {
            plusBtn = node;
            break;
          }
        }
      }
      if (!plusBtn && e.target && e.target.closest) {
        plusBtn = e.target.closest('button[name="plus"]');
      }
      if (!plusBtn) return;

      var ctxP = window.StoreContext && window.StoreContext.get ? window.StoreContext.get() : null;
      if (!ctxP || !ctxP.store_code) return;

      var host = findQtySelectorHostFromNode(plusBtn);
      var cartComp = host && host.tagName === 'CART-QUANTITY-SELECTOR-COMPONENT' ? host : null;
      var pdpComp = host && host.tagName === 'QUANTITY-SELECTOR-COMPONENT' ? host : null;

      if (cartComp) {
        var inpC = qtyInputInSelectorComp(cartComp);
        if (!inpC) return;
        var capC = parseInt(inpC.max, 10);
        var vC = parseInt(inpC.value, 10) || 0;
        if (Number.isFinite(capC) && capC > 0 && vC >= capC) {
          var lineC = getCartLineIndexFromQtyHost(cartComp);
          if (lineC) {
            _cartLinePointerCapUntil[lineC] = Date.now() + 1100;
          }
          showLocationStockCapMessage(capC, 'cart', cartComp);
        }
        return;
      }

      if (pdpComp && findCartAddFormFromNode(pdpComp)) {
        var inpP = qtyInputInSelectorComp(pdpComp);
        if (!inpP) return;
        var maxP = parseInt(inpP.max, 10);
        var cartQP = parseInt(inpP.getAttribute('data-cart-quantity'), 10) || 0;
        var minP = parseInt(inpP.min, 10) || 1;
        if (!Number.isFinite(maxP) || maxP <= 0) return;
        var effP = Math.max(maxP - cartQP, minP);
        var vP = parseInt(inpP.value, 10) || 0;
        if (vP >= effP) {
          showLocationStockCapMessage(maxP, 'product');
        }
      }
    },
    true
  );

  var _cartCountReconcileTimer;
  var CART_COUNT_SYNC_SRC = 'fabelle-cart-count-sync';
  /** Skip blur "over max" toast right after + at cap already showed (same line). */
  var _cartLinePointerCapUntil = {};

  /**
   * Total cart units: prefer summing line quantities (same as Shopify line table), then item_count.
   * @param {*} cart
   * @returns {number}
   */
  function totalUnitsFromShopifyCart(cart) {
    if (!cart) return 0;
    if (Array.isArray(cart.items)) {
      var s = 0;
      var i;
      for (i = 0; i < cart.items.length; i++) {
        s += Number(cart.items[i].quantity) || 0;
      }
      return s;
    }
    if (typeof cart.item_count === 'number') return cart.item_count;
    return 0;
  }

  /** Cart page title + summary use SSR Liquid counts; line qty can change via AJAX — align all to /cart.js. */
  function updateCartPageCountDom(n) {
    if (typeof n !== 'number' || n < 0) return;
    var h = document.querySelector('h1.cart-title-heading');
    if (h) h.textContent = n > 0 ? 'Cart (' + n + ')' : 'Cart';
    document.querySelectorAll('.js-cart-page-item-count').forEach(function (cEl) {
      cEl.textContent = String(n);
    });
    document.querySelectorAll('.js-cart-page-item-label').forEach(function (lEl) {
      lEl.textContent = n === 1 ? 'Item' : 'Items';
    });
    document.querySelectorAll('.cart-items__wrapper span[ref="cartItemCount"]').forEach(function (vis) {
      vis.textContent = String(n);
    });
  }

  /**
   * Sync every cart badge (header + mini-cart drawer heading) to Shopify item_count.
   */
  function syncHeaderCartBubbleAbsolute(n) {
    if (typeof n !== 'number' || n < 0) return;
    var display = n < 100 ? String(n) : '';
    document.querySelectorAll('[data-testid="cart-bubble"]').forEach(function (countEl) {
      countEl.textContent = display;
      countEl.classList.toggle('hidden', n === 0);
      var bubble = countEl.closest('.cart-bubble');
      if (bubble) bubble.classList.toggle('visually-hidden', n === 0);
    });
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      if (icon.classList) icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });
    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: display, timestamp: Date.now() })
      );
    } catch (err) {}
  }

  /** Single path: DOM + header bubble + one cart:update (theme listeners; sync source skips debounced re-fetch). */
  function applyCartCountUiFromShopifyCart(cart) {
    var n = totalUnitsFromShopifyCart(cart);
    updateCartPageCountDom(n);
    syncHeaderCartBubbleAbsolute(n);
    if (typeof window.fabelleUpdateMobileNavCartBadge === 'function') {
      window.fabelleUpdateMobileNavCartBadge(n);
    }
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount: n,
            source: CART_COUNT_SYNC_SRC,
            resource: cart,
          },
        },
      })
    );
  }

  function reconcileCartCountsWithShopify() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCartCountUiFromShopifyCart(cart);
      })
      .catch(function () {});
  }

  function scheduleCartCountReconcile() {
    clearTimeout(_cartCountReconcileTimer);
    _cartCountReconcileTimer = setTimeout(reconcileCartCountsWithShopify, 250);
  }

  document.addEventListener('DOMContentLoaded', function () {
    validatePDP();
    validateCartPageUi();
    if (document.querySelector('h1.cart-title-heading')) {
      scheduleCartCountReconcile();
    }
  });

  /**
   * Theme morphs cart HTML after /cart/change.js; Liquid restores variant.quantity_rule.max on inputs,
   * wiping FCB caps. Re-apply limits after DOM updates (dispatch is sync; morph runs in same task).
   */
  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    var src = d && d.source;
    var needDebounceReconcile = true;
    if (src === CART_COUNT_SYNC_SRC) {
      needDebounceReconcile = false;
    } else if (src === 'cart-items-component') {
      /* Do not trust event-derived counts alone — fetch /cart.js (Liquid-equivalent totals from Shopify). */
      reconcileCartCountsWithShopify();
      needDebounceReconcile = false;
    } else if (
      d &&
      typeof d.itemCount === 'number' &&
      typeof src === 'string' &&
      src.indexOf('fabelle-') === 0
    ) {
      syncHeaderCartBubbleAbsolute(d.itemCount);
      if (document.querySelector('h1.cart-title-heading')) updateCartPageCountDom(d.itemCount);
      needDebounceReconcile = false;
    }
    if (
      needDebounceReconcile &&
      (document.querySelector('h1.cart-title-heading') || document.querySelector('cart-icon'))
    ) {
      scheduleCartCountReconcile();
    }

    Object.keys(_cartLineInvTimers).forEach(function (line) {
      clearTimeout(_cartLineInvTimers[line]);
    });
    _cartLineInvTimers = {};
    setTimeout(function () {
      validateCartPageUi();
    }, 0);
  });

  document.addEventListener('store_context:updated', function () {
    validatePDP();
    validateCartPageUi();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name="updates[]"]') && findQtySelectorHostFromNode(t)) {
      enforceCartQuantityLimits();
    }
    if (t && (t.matches('variant-selects select') || t.matches('variant-radios input'))) {
      setTimeout(validatePDP, 300);
    }
  });
})();
